import posthog from 'posthog-js';
import { history } from '@umijs/max';

const POSTHOG_API_HOST = 'https://ph.bluemediagroup.cn';
const POSTHOG_API_CONFIG = {
  production: {
    apiKey: 'phc_OrvLzSwlBux0vC1EPXaubCvdoLI3FXTbDlqpl3I3zES',
  },
  development: {
    apiKey: 'phc_7lmdZB12psKaknVrBUdjiuOxM0GSVGjui3FZ6ryfPk5',
  },
};
// 根据域名判断环境
const isProduction =
  typeof window !== 'undefined' && window.location.hostname === 'luban.bluemediagroup.cn';
const apiKey = isProduction
  ? POSTHOG_API_CONFIG.production.apiKey
  : POSTHOG_API_CONFIG.development.apiKey;

// PostHog 配置
const POSTHOG_CONFIG = {
  apiKey,
  api_host: POSTHOG_API_HOST, // 私有化部署替换为你的地址
  capturePageview: false, // 关闭默认页面浏览捕获（后续手动结合 Umi 路由处理）
  capturePageleave: true,
  autocapture: true, // 自动捕获点击、输入等行为（可选，根据需求关闭）
  disable_session_recording: !isProduction, // 仅生产环境开启会话录制
  // 会话录制核心配置
  session_recording: {
    sample_rate: isProduction ? 0.3 : 0, // 30% 采样比例
    // 过滤掉过短的无效会话（< 3秒的通常无价值）
    minimum_duration: 3000,
    recordCanvas: false, // 是否录制 Canvas（默认关闭，按需开启）
    recordCrossOriginIframes: false, // 是否录制跨 iframe 点击（默认关闭）
    maskAllInputs: true, // 掩码所有输入框内容（隐私合规，强烈建议开启）
    maskTextSelector: 'input, textarea, [contenteditable]', // 自定义掩码元素
    // 排除不需要录制的页面/元素（可选）
    excludeElements: '[data-ph-no-record]', // 给元素加此属性可跳过录制
    maskCapturedNetworkRequestFn: undefined, // 网络请求掩码函数
  },
};

// 初始化 PostHog
export const initPostHog = () => {
  if (typeof window !== 'undefined' && !posthog.__loaded) {
    posthog.init(POSTHOG_CONFIG.apiKey, {
      ...POSTHOG_CONFIG,
      // 结合 Umi history 监听路由，确保页面跳转时正确上报
      loaded: (ph) => {
        // 监听路由变化，上报页面浏览
        history.listen(({ location }) => {
          ph.capture('$pageview', {
            pathname: location.pathname,
            query: Object.fromEntries(new URLSearchParams(location.search)),
            referrer: document.referrer,
            title: document.title,
          });
        });

        // 监听标签页可见性，离开超过3秒才停止录制
        // 离开标签页 → 启动3秒定时器
        // 3秒内回来 → 清除定时器，录制不中断
        // 超过3秒 → 停止录制
        // 之后回来 → 恢复录制
        let visibilityTimer: ReturnType<typeof setTimeout> | null = null;
        let recordingStopped = false;
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') {
            visibilityTimer = setTimeout(() => {
              ph.stopSessionRecording();
              recordingStopped = true;
            }, 3000);
          } else if (document.visibilityState === 'visible') {
            if (visibilityTimer) {
              clearTimeout(visibilityTimer);
              visibilityTimer = null;
            }
            if (recordingStopped) {
              ph.startSessionRecording();
              recordingStopped = false;
            }
          }
        });
      },
    });
  }
};

// 手动埋点事件
export const posthogCapture = (eventName: string, properties?: Record<string, unknown>) => {
  if (posthog?.__loaded) {
    posthog.capture(eventName, properties);
  }
};

// 设置用户标识（登录后调用）
export const identifyUser = (userId?: string, userProperties?: Record<string, unknown>) => {
  if (posthog.__loaded) {
    posthog.identify(userId, userProperties);
  }
};

// 清除用户标识（登出后调用）
export const resetPosthogUser = () => {
  if (posthog.__loaded) {
    posthog.reset();
  }
};

// 导出原始实例（备用）
export default posthog;
